export enum NewScanScheduleStep {
  ScanDetails = "SCAN_DETAILS",
  AttachProviders = "ATTACH_PROVIDERS",
  AttachWorkerPool = "ATTACH_WORKER_POOL",
  DefineScope = "DEFINE_SCOPE",
  ResourceFilters = "RESOURCE_FILTERS",
  SetFrequency = "SET_FREQUENCY",
  Summary = "SUMMARY",
}

export type NewScanScheduleStepHeader = {
  title: string;
  description: string;
};

export type NewScanScheduleFormFields = {
  name: string;
  space: string;
  labels: { value: string }[];
  description: string;
  // The AWS provider config is edited flat here: one version + integration for the whole scan,
  // and one ScanProviderConfigInput entry per selected region (each sharing that version and
  // integration).
  providerVersion: string;
  integrationId: string;
  regions: string[];
  workerPoolId: string;
  resourceTypes: string[];
};
